module.exports = __webpack_public_path__ + "img/evo_logo.644f8152.png";